/**
 * RegionSelector Component
 * 
 * A dropdown selector for choosing between different regional data collections.
 * Used in Suppliers and Products dashboards to filter data by region.
 * 
 * @component
 * @example
 * <RegionSelector
 *   value={region}
 *   onChange={handleRegionChange}
 * />
 */

import React from 'react';
import './RegionSelector.scss';

export type Region = 'tr' | 'en' | 'de';

interface RegionSelectorProps {
  /** Current selected region */
  value: Region;
  /** Callback when region changes */
  onChange: (region: Region) => void;
  /** Whether the selector is disabled */
  disabled?: boolean;
  /** Custom class name */
  className?: string;
}

const RegionSelector: React.FC<RegionSelectorProps> = ({
  value,
  onChange,
  disabled = false,
  className = ''
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    onChange(e.target.value as Region);
  };

  return (
    <div className={`region-selector ${className}`}>
      <label htmlFor="region-select" className="region-selector__label">
        Region:
      </label>
      <select
        id="region-select"
        className="region-selector__select"
        value={value}
        onChange={handleChange}
        disabled={disabled}
      >
        <option value="tr">🇹🇷 Turkey</option>
        <option value="en">🇬🇧 International</option>
        <option value="de">🇩🇪 Germany</option>
      </select>
    </div>
  );
};

export default RegionSelector;




